export default function (vehicle: Cinch.DealerVehicleAdvertSummary | Cinch.DirectVehicleAdvertSummary) {
  return [
    { label: 'Body Type', value: vehicle.bodyType },
    { label: 'Colour', value: vehicle.colour },
    { label: 'Engine Size', value: vehicle.engineSize },
    { label: 'Fuel Type', value: vehicle.fuelType },
    { label: 'Mileage', value: vehicle.mileage },
    { label: 'Transmission Type', value: vehicle.transmissionType },
    { label: 'Vehicle Year', value: vehicle.vehicleYear },
    { label: 'Doors', value: vehicle.doors },
  ]
    .filter(({ value }) => value !== '-')
    .filter(({ value }) => !!value)
}
